
export const queryServicesQuery = `
    query DomainServices($filter: ServiceFilter, $paging: CursorPaging)
    {
        domainServices(filter: $filter, paging: $paging)
        {
            pageInfo {
            endCursor
            hasNextPage
            hasPreviousPage
            startCursor
            }
            edges
            {
                node
                {
                    id
                    name
                    description
                    duration
                    isActive
                    price
                    image
                    isVideoService
                }
            }
            pageInfo
            {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
            }
        }
    }
`;

export const queryCategoriesQuery = `
    query ServiceCategories($filter: ServiceCategoryFilter, $paging: CursorPaging) {
  serviceCategories(filter: $filter, paging: $paging) {
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    edges {
      node {
        id
        image
        isDeleted
        name
        description
      }
    }
  }
}
`;

export const timeSlotsQuery = `
query GetAvailableSlots($date: DateTime!, $serviceIds: [String!]!, $locationId: [String!]) {
  getAvailableSlots(date: $date, serviceIds: $serviceIds, locationId: $locationId)
}
`;

export const queryWidgetConfigurationQuery = `
    query PublicWidgetConfiguration {
        widgetConfiguration: publicWidgetConfiguration {
        domainConfiguration {
                id
                widgetConfiguration
                layoutType
                isGiftActivated
                isPaymentActivated
                isPaymentMandatory
                isLocationsActivated
                isProvidersActivated
                isCategoriesActivated
                currency {
                    symbol
                }
            domain {
                name
            }
        }
            bookingPageConfig {
      id
      configuration
      isActive
    }
      }

    }
`;
